<section fxLayoutAlign="center" fxFlex bgAsset="background_404.svg">
  <article>
    <h3>Page not found</h3>
    <p>The page you're looking for cannot be found.</p>
    <a mat-flat-button color="accent" [routerLink]="['/c/o/marketplace/home']">Back to Homepage</a>
  </article>
</section>
